import * as React from "react";
import { useRef } from "react";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Divider, Grid, IconButton, Stack } from "@mui/material";
import { ModifiedTextField } from "./textField";
import CloseIcon from "@mui/icons-material/Close";
import { DropzoneArea } from "../common/dropZone";
import { useStoreState, useStoreActions } from "easy-peasy";
import { findRTCurveValues } from "../../utils/xmlParser";
import { validateNewForm } from "./../../utils/graph-helper";

export default function VirginResinDialog({ open, setOpen }) {
  const [isUploadDisabled, setIsUploadDisabled] = useState(true);
  let requirements = useStoreState((state) => state.requirements);
  let setRequirements = useStoreActions((actions) => actions.setRequirements);

  let virginDialogErrors = useStoreState((state) => state.virginDialogErrors);
  let setVirginDialogErrors = useStoreActions(
    (actions) => actions.setVirginDialogErrors
  );

  let newFormErrors = useStoreState((state) => state.newFormErrors);
  const setNewFormErrors = useStoreActions(
    (actions) => actions.setNewFormErrors
  );

  const [resinName, setResinName] = useState("");
  const [batchNumber, setBatchNumber] = useState("");
  const [thickness, setThickness] = useState("");
  const [rtCurve, setRTCurve] = useState({ rCurve: [], tCurve: [] });
  const [fileName, setFileName] = useState("");

  const nameRef = useRef("");

  useEffect(() => {
    /* check here for form validation as well*/
    console.log(virginDialogErrors);
    let erroRes = validateNewForm(virginDialogErrors);
    if (
      erroRes &&
      fileName &&
      virginDialogErrors?.thickness?.required == false &&
      virginDialogErrors?.resinName?.required == false
    ) {
      setIsUploadDisabled(false);
    } else {
      setIsUploadDisabled(true);
    }
  }, [open, isUploadDisabled]);

  useEffect(
    () => {
      if (
        requirements &&
        requirements.resinRequirement &&
        requirements.resinRequirement.newResinvirgin
      ) {
        let data = requirements.resinRequirement.newResinvirgin;
        setResinName(data.resinName);
        setBatchNumber(data.batchNumber);
        setThickness(data.thickness);
        setRTCurve(data.rtCurve);
        setFileName(data.fileName);
      }
      if (!open) {
        const errorRespMainForm = validateNewForm(virginDialogErrors);
        if (errorRespMainForm) {
          setIsUploadDisabled(false);
        } else {
          setIsUploadDisabled(true);
        }
      }
    },
    [
      requirements.selectedVirginResin,
      requirements.resinRequirement.newResinvirgin,
    ],
    [open]
  );

  //  button iside pop up when we click on this button everything on the pop up will be saved in state
  const handleUpload = () => {
    // Handle validation  here
    // Updating state on upload button click
    setRequirements({
      ...requirements,
      selectedVirginResin: "",
      resinRequirement: {
        newResinRecycled: requirements.resinRequirement.newResinRecycled,
        newResinvirgin: {
          resinName,
          batchNumber,
          thickness,
          rtCurve,
          fileName: fileName,
        },
      },
    });
    setOpen(false);
  };

  //  close button to close the pop up
  const handleClose = () => {
    setOpen(false);
    setIsUploadDisabled(true);
  };

  //  this called when we upload file in dropzone
  //  - read the cxf file then it will convert xml to JSON then we can read easily
  //  - read the reflectance and transmittance RT curve from the file
  //  -  before saving the RT curve into state it will pass from validation if validation pass will save in state otherwise error in console.log()

  const handleUploadFile = async (xmlJson, fileName) => {
    setFileName(fileName);
    console.log(fileName);
    let data = findRTCurveValues(xmlJson);

    if (data != -1) {
      setRTCurve(data);
      if (fileName && nameRef.thickness != "" && nameRef.resinName != "") {
        setIsUploadDisabled(false);
      } else {
        setIsUploadDisabled(true);
      }
      // call validate field option
    } else {
      setRTCurve({ rCurve: [], tCurve: [] });
      console.log("Invalid File Format");
      setIsUploadDisabled(true);
      // disbale upload button
    }
  };

  //  when we click on cross arrow button this function will trigger to reset the state
  const handleRemoveFile = () => {
    setIsUploadDisabled(true);
    setFileName("");
  };

  const validateField = (name, value) => {
    let errorMessage = "";
    let stateObj = {};

    switch (name) {
      case "thickness": // Validation for the 'name' field
        if (value.trim() === "") {
          errorMessage = "Thickness is required.";
          stateObj = {
            required: true,
            highlight: true,
          };
        } else if (value < 0.1 || value > 5) {
          errorMessage = "Thickness should be greater than 0.1 and less than 5";
          stateObj = {
            required: true,
            highlight: true,
          };
        } else {
          stateObj = {
            required: false,
            highlight: false,
          };
          errorMessage = "";
        }
        setVirginDialogErrors(() => {
          // This `prevErrors` is the latest state from the store
          return {
            ...virginDialogErrors,
            ["thickness"]: stateObj,
            ["resinName"]: stateObj,
          };
        });
        setThickness(parseFloat(value));
        nameRef.thickness = value;

        /* Check both inputs are updated or not */
        break;

      case "upload":
        if (value.trim() === "") {
          errorMessage = "File is required.";
        } else {
          errorMessage = "";
        }
        console.log("error");
        break;

      case "resinName":
        if (value.trim() === "") {
          errorMessage = "Resin name is required.";
          stateObj = {
            required: true,
            highlight: true,
          };
        } else if (value.length > 55) {
          errorMessage = "Required max 55 charachter's";
          stateObj = {
            required: true,
            highlight: true,
          };
        } else {
          errorMessage = "";
          stateObj = {
            required: false,
            highlight: false,
          };
        }
        setResinName(value);
        nameRef.resinName = value;
        setVirginDialogErrors(() => {
          // This `prevErrors` is the latest state from the store
          return {
            ...virginDialogErrors,
            ["resinName"]: stateObj,
          };
        });
      default:
        // No validation rule for this field
        break;
    }
    return errorMessage;
  };

  const inputChange = (event) => {
    let input = event.target.value;
    let name = event.target.name;
    console.log(name);
    // Prevent exceeding number of digits or decimal points
    const errorMessage = validateField(name, input);
    let obj = {};
    if (errorMessage == "") {
      obj = {
        required: false,
        highlight: false,
        error: "",
      };
    } else {
      obj = {
        required: true,
        highlight: true,
        error: errorMessage,
      };
    }

    setVirginDialogErrors(() => {
      // This `prevErrors` is the latest state from the store
      return {
        ...virginDialogErrors,
        [name]: obj,
      };
    });
    let errors = {
      ...virginDialogErrors,
      [name]: obj,
    };
    console.log(errors);
    const errorRespMainForm = validateNewForm(errors);
    console.log(errorRespMainForm);
    console.log(fileName);
    if (errorRespMainForm && fileName !== "") {
      console.log("if");
      setIsUploadDisabled(false);
      setNewFormErrors(() => {
        // This `prevErrors` is the latest state from the store
        return {
          ...newFormErrors,
          ["virgin"]: {
            required: false,
            highlight: false,
          },
        };
      });
    } else {
      console.log("else");
      setNewFormErrors(() => {
        // This `prevErrors` is the latest state from the store
        return {
          ...newFormErrors,
          ["virgin"]: {
            required: true,
            highlight: false,
          },
        };
      });
      setIsUploadDisabled(true);
      console.log(isUploadDisabled);
    }
  };

  return (
    <React.Fragment>
      <Dialog open={open} onClose={handleClose} fullWidth={true}>
        <DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box
            sx={{
              color: "#303C43",
              fontSize: 28,
              fontFamily: "Source Sans Pro",
              fontWeight: "600",
              lineHeight: "36px",
              wordWrap: "break-word",
              mb: 1,
            }}
          >
            New Virgin Resin
          </Box>
        </DialogTitle>
        <Divider sx={{ color: "#D9D9D9" }} />
        <DialogContent>
          <Box
            sx={{
              width: "95%",
              height: "100%",
              background: "white",
              borderRadius: "4px",
              border: "1px #C7C9C7 solid",
              padding: "12px",
              mb: 2,
              mt: 2,
            }}
          >
            <DropzoneArea
              handleUploadFile={handleUploadFile}
              fileName={fileName}
              handleRemoveFile={handleRemoveFile}
              noOfColorPoints={-1}
            />
            <Grid container sx={{ mt: 2 }}>
              <Grid xs={12}>
                <ModifiedTextField
                  heading="Resin Name"
                  name="resinName"
                  value={resinName}
                  //onChange={(e) => setResinName(e.target.value)}
                  onChange={(e) => inputChange(e)}
                  isError={virginDialogErrors?.resinName?.highlight}
                  errorMessage={
                    virginDialogErrors?.resinName?.highlight
                      ? virginDialogErrors?.resinName?.error
                      : ""
                  }
                />
              </Grid>

              <Grid xs={12} sx={{ p: 1 }}></Grid>
              <Grid container xs={12}>
                <Grid xs={3}>
                  <ModifiedTextField
                    heading="Batch Number"
                    name="batchNumber"
                    value={batchNumber}
                    onChange={(e) => setBatchNumber(e.target.value)}
                  />
                </Grid>
                <Grid xs={1}></Grid>
                <Grid xs={3}>
                  <ModifiedTextField
                    heading="Thickness (mm)"
                    placeholder={"0.1-5"}
                    type="number"
                    name="thickness"
                    value={thickness}
                    //onChange={(e) => setThickness(parseFloat(e.target.value))}
                    onChange={(e) => inputChange(e)}
                    isError={virginDialogErrors?.thickness?.highlight}
                    errorMessage={
                      virginDialogErrors?.thickness?.highlight ? "0.1 to 5" : ""
                    }
                  />
                </Grid>
                <Grid xs={5}></Grid>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: "flex-start",
            height: "80px",
            marginLeft: "3%",
          }}
        >
          <Button
            onClick={handleClose}
            sx={{
              mr: 1,
              width: "134px",
              height: "40px",
              padding: "8px 40px",
              borderRadius: "24px",
              border: "1px solid #385DAE",
              gap: "10px",
              color: "#385DAE",
              textTransform: "none",
              marginRight: "20px",
              fontFamily: "Source Sans Pro",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleUpload}
            disabled={isUploadDisabled}
            sx={{
              mr: 1,
              width: "134px",
              height: "40px",
              padding: "8px 40px",
              borderRadius: "24px",
              border: "1px solid #385DAE",
              gap: "10px",
              background: "linear-gradient(90deg, #3A5DAE 0%, #4EC3E0 100%)",
              border: "1px solid",
              color: "#FFFFFF",
              textTransform: "none",
              fontFamily: "Source Sans Pro",
            }}
          >
            Upload
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
